// Admin přehled veřejných Fokus seznamů (RecruitmentFocus stránka, jen admin).
import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash, PencilSimple } from "@phosphor-icons/react";
import { focusListsAdmin, focusListAdminGet, focusListDelete } from "../../lib/focus-api";

export default function FocusListsAdminSection({ refresh, onOpen }) {
    const [lists, setLists] = useState([]);

    useEffect(() => {
        focusListsAdmin().then((d) => setLists(d.lists || [])).catch(() => {});
    }, [refresh]);

    const open = async (l) => {
        try { onOpen(await focusListAdminGet(l.id)); }
        catch { toast.error("Načtení seznamu selhalo"); }
    };

    const remove = async (l) => {
        try { await focusListDelete(l.id); setLists(lists.filter((x) => x.id !== l.id)); toast.success("Seznam smazán"); }
        catch { toast.error("Smazání selhalo"); }
    };

    if (!lists.length) return null;
    return (
        <div className="border border-fa-yellow/30 bg-fa-yellow/5 p-4 space-y-2" data-testid="focus-lists-admin-section">
            <p className="font-mono text-[9px] uppercase tracking-widest text-fa-yellow">Fokus seznamy pro čtenáře ({lists.length})</p>
            {lists.map((l) => (
                <div key={l.id} className="flex items-center gap-2 border border-white/10 bg-black/40 px-3 py-2 flex-wrap" data-testid={`focus-list-admin-row-${l.id}`}>
                    <span className={`font-mono text-[8px] uppercase tracking-widest px-1.5 py-0.5 border ${l.status === "published" ? "border-fa-mint/60 text-fa-mint" : "border-fa-yellow/50 text-fa-yellow"}`}>
                        {l.status === "published" ? "Publikováno" : "Koncept"}
                    </span>
                    <span className="font-display font-bold text-sm">{l.title}</span>
                    <span className="font-mono text-[9px] text-white/45">{l.player_count} hráčů</span>
                    {l.status === "published" && (
                        <a href={`/fokus/${l.slug}`} target="_blank" rel="noreferrer" className="font-mono text-[9px] text-fa-sky underline">/fokus/{l.slug}</a>
                    )}
                    <div className="ml-auto flex gap-2">
                        <button type="button" onClick={() => open(l)} className="text-fa-sky" data-testid={`focus-list-edit-${l.id}`}><PencilSimple size={13} /></button>
                        <button type="button" onClick={() => remove(l)} className="text-white/30 hover:text-red-400" data-testid={`focus-list-delete-${l.id}`}><Trash size={13} /></button>
                    </div>
                </div>
            ))}
        </div>
    );
}
